import { render, staticRenderFns } from "./AddSubscriptionPlanModal.vue?vue&type=template&id=64d86411&scoped=true&"
import script from "./AddSubscriptionPlanModal.vue?vue&type=script&lang=ts&"
export * from "./AddSubscriptionPlanModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddSubscriptionPlanModal.vue?vue&type=style&index=0&id=64d86411&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d86411",
  null
  
)

export default component.exports